import { defineMessages } from 'react-intl'

export default defineMessages({
  edit: {
    id: 'Edit',
    defaultMessage: 'Edit'
  },
  delete: {
    id: 'Delete',
    defaultMessage: 'Delete'
  },
  viewLogs: {
    id: 'ViewLogs',
    defaultMessage: 'View Logs'
  }
})
